module.exports = __webpack_public_path__ + "static/4-events-78f6f34e85ad7ac4e8c96aed26611e56.jpg";